module.exports = global.config = {
    api_server: "https://admin.htultrasound.com/v1/",
    asset_server: "https://admin.htultrasound.com",
    public_server: "https://demo.htultrasound.com",
    items_per_page: 20,
    settings_token: "title",
};